import { unitMapping } from 'lib/style';

export const Cards = ({ size = 1.5 }: { size?: keyof typeof unitMapping }) => (
  <svg
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.27617 0.717739C6.16798 0.320297 5.75951 0.0844823 5.36123 0.189531L0.731039 1.41076C0.328285 1.51698 0.0892419 1.93104 0.198645 2.33295L2.2486 9.86367C2.35679 10.2611 2.76526 10.4969 3.16354 10.3919L3.50084 10.3029L3.47551 10.396L8.83664 11.81C9.23493 11.915 9.6434 11.6792 9.75159 11.2818L11.8015 3.75106C11.9109 3.34915 11.6719 2.93509 11.2691 2.82887L6.50909 1.57339L6.27617 0.717739ZM5.592 9.75137L7.79373 9.17066C8.19649 9.06443 8.43553 8.65037 8.32613 8.24846L6.86184 2.86927L10.5545 3.84321L8.72152 10.5768L5.592 9.75137Z"
      fill="white"
    />
  </svg>
);
